<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-7 bg-gradient">
    <h1>Переводы P2P</h1>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <div class="content_block">
            <BaseTable
            :type="type"
            />
            <div v-if="loading">loading...</div>
          </div> <!-- content_block -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import BaseTable from '@/views/Tables/RegularTables/LightTable.vue'

export default {
  name: 'STransfers',
  data() {
    return {
      tableData: [],
      loading: false,
      currentPage: 1,
      type: 's'
    }
  },
  components: {
    BaseTable
  },
  methods: {
  },
  mounted() {
  },
  created () {
  },
};
</script>

<style scoped>
.mypb {
  padding-bottom: 63px;
}
h1 {
  color: #fff;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
}
h3 {
  font-size: 22px;
  padding-bottom: 0.5rem;
  font-weight: 600;
}
.content_block {
  display: block;
  border-radius: 0.375rem;
  position: relative;
}
.bg-gradient {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important
}
.add_btn {
  border: none;
  text-align: center;
  background: rgba(1, 204, 1, 0.288);
  color: rgba(3, 173, 3, 0.904);
  font-size: 17px;
  width: 330px;
  border-radius: 7px;
  margin-bottom: 8px;
  height: 45px;
  font-weight: 500;
  outline: none!important;
  transition: all 0.2s;
}
.add_btn:hover {
  cursor: pointer;
  background: rgba(1, 204, 1, 0.432);
}
.add_btn:active {
  background: rgba(1, 204, 1, 0.432);
}
.add_btn:focus {
  background: rgba(1, 204, 1, 0.432);
}
</style>
